import { useSuspenseQuery } from '@tanstack/react-query'

import { GetNacionalidadesService } from '@/http/get-nacionalidades.service'
import { nacionalidadeClienteKeys } from '@/utils/cliente-query-keys'

export const useSuspenseNacionalidade = () => {
  return useSuspenseQuery({
    queryKey: nacionalidadeClienteKeys.lista(),
    queryFn: async () => new GetNacionalidadesService().execute().then((res) => res.data),
  })
}
